import r, { forwardRef as C } from "react";
import { SingleSelect as g } from "./SingleSelect/SingleSelect.js";
import { MultiSelect as O } from "./MultiSelect/MultiSelect.js";
import { ChevronDown as v } from "@olxbr/ds-icons";
import { Chip as y } from "../Chip/Chip.js";
var D = Object.defineProperty,
  f = Object.getOwnPropertySymbols,
  N = Object.prototype.hasOwnProperty,
  R = Object.prototype.propertyIsEnumerable,
  p = (l, e, t) => e in l ? D(l, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : l[e] = t,
  j = (l, e) => {
    for (var t in e || (e = {})) N.call(e, t) && p(l, t, e[t]);
    if (f) for (var t of f(e)) R.call(e, t) && p(l, t, e[t]);
    return l;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const S = C((l, e) => {
  const {
      children: t,
      "aria-label": u,
      icon: _,
      variant: o,
      selected: b,
      disabled: h,
      onAction: a,
      onSelectedChange: c,
      SelectionItens: I = [],
      selectionItems: i = I || [],
      defaultSelectedItemIndex: E,
      tag: d,
      href: m
    } = l,
    w = n => {
      a == null || a(n);
    },
    s = n => {
      c == null || c(n), l.setSelectedItems && l.setSelectedItems(n);
    };
  return r.createElement(r.Fragment, null, (o === "default" || o === "action") && r.createElement(y, j({
    "data-ds-component": "DS-Chips",
    "aria-label": u,
    className: "olx-chips__button",
    checked: b,
    disabled: h,
    onClick: w,
    tag: d
  }, d === "a" && m ? {
    href: m
  } : {}), _, t, o === "action" && r.createElement(v, null)), o === "multi-selection" && r.createElement(O, {
    selectionItems: i,
    onSelectedChange: s,
    ref: e
  }), o === "single-selection" && r.createElement(g, {
    selectionItems: i,
    defaultSelectedItemIndex: E,
    onSelectedChange: s,
    ref: e
  }));
});
S.displayName = "Chips";
export { S as Chips };